export default __webpack_public_path__ + "static/media/chat.d59ef880.svg";